import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setLanguage } from './languageSlice';
import { RootState } from '@/platform';

export const useReduxLanguageAdaptor = () => {
  const dispatch = useDispatch();
  const { currentLanguage } = useSelector((state: RootState) => state.language);

  return {
    getCurrentLanguage: () => currentLanguage,
    setCurrentLanguage: (language: string) => dispatch(setLanguage(language)),
  };
};
